import moment from 'moment';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Page, RestrictedPage } from '../shared';

import { ImportUserModal } from '../modals';

import { beginEditingUser } from '../../actions/users';

import {
  currentUserIsAdmin,
  currentUserIsSuperAdmin,
  currentUserRole,
  currentUserCan,
  logError,
  getIcon,
} from '../../util';

import { UpdateUserModal } from '../modals';

import { IntegrationSelector } from '../../selectors';

//import * as Sentry from '@sentry/browser';

class PeoplePage extends Component {

  state = {
    searchText: '',
    pageMessage: null,
    importingUser: false,
  }

  componentWillMount(){
    //this.beginEditingUser = this.beginEditingUser.bind(this);
  }

  beginCreatingNewUser(){
    this.props.beginEditingUser();
  }
  beginImportingUser(){
    this.setState({
      importingUser: true
    });
  }
  beginEditingUser(userData){
    this.props.beginEditingUser(userData);
  }

  getTeamLeaderRolesForPerson(person){
    const teams = this.props.teams;

    return _.filter(teams, team => {
      return team.leaders.indexOf(person._id) !== -1;
    }) || [];
  }
  getTeamMemberRolesForPerson(person){
    const teams = this.props.teams;

    return _.filter(teams, team => {
      return team.members.indexOf(person._id) !== -1;
    }) || [];
  }

  renderTeamsForPerson(teams){
    return _.map(teams, team => {
      return <li key={team._id}>{team.name}</li>
    });
  }

  renderPerson(person){

    const id = person._id;
    const archived = person._deleted;
    const archivedOn = person.deletedOn;
    const firstName = person.firstName || '';
    const lastName = person.lastName || '';
    const role = person.role;
    const salesforceId = person.salesforceId || false;
    const salesforceIdAlternative = person.salesforceIdAlternative || false;
    const pendingAssessment = person.pendingAssessment || null;
    const pendingAssessmentString = pendingAssessment && pendingAssessment.assessmentName + ':' + pendingAssessment.profileName + (pendingAssessment.status ? ` (${pendingAssessment.status})` : '');

    const { integration } = this.props;

    const leaderOfTeams = this.getTeamLeaderRolesForPerson(person);
    const memberOfTeams = this.getTeamMemberRolesForPerson(person);

    return (
      <li key={person._id} className={`person ${archived ? 'archived' : ''}`}>
        <div className="name">{firstName.toLowerCase() + ' ' + lastName.toLowerCase()}&nbsp;</div>
        {archived &&
          <div className="archived-on">Archived {moment((archivedOn && archivedOn.toDate())).fromNow()}</div>
        }
        {!archived &&
          <div className="permissions">{role === 'employee' ? 'seller' : role}&nbsp;</div>
        }
        <p className="id">{id}&nbsp;</p>
        {integration === 'salesforce' && salesforceId &&
          <p className="id alt">{getIcon('salesforce')}&nbsp;<span>{salesforceId}</span>&nbsp;</p>
        }
        {integration === 'salesforce' && salesforceIdAlternative &&
          <p className="id alt">{getIcon('salesforce')}&nbsp;<span>{salesforceIdAlternative}**</span>&nbsp;</p>
        }
        {leaderOfTeams.length > 0 &&
          <div className="teams">Leader of <ul>{this.renderTeamsForPerson(leaderOfTeams)}</ul></div>
        }
        {memberOfTeams.length > 0 &&
          <div className="teams">Member of <ul>{this.renderTeamsForPerson(memberOfTeams)}</ul></div>
        }
        {pendingAssessment &&
          <div className="teams">Pending assessment: <ul><li>{pendingAssessmentString}</li></ul></div>
        }

        <div className="actions">
          {currentUserIsAdmin() && !archived &&
            <button onClick={() => {this.beginEditingUser(person); } }>Edit</button>
          }
          {currentUserIsAdmin() &&
            <Link to={`people/${person._id}/profile`}>View</Link>
          }
          {currentUserRole() === 'salesleader' &&
            <Link to={`people/${person._id}/sprint`}>View</Link>
          }
        </div>
      </li>
    )
  }
  renderEmployees(){

    const filteredEmployees = _.filter(this.props.employees, employee => {
      const loweredSearchText = this.state.searchText.toLowerCase();

      const employeeRole = employee.role + (employee.role === 'employee' ? ' seller' : '');
      const employeeName = (employee.firstName + ' ' + employee.lastName).toLowerCase();

      return employeeName.indexOf(loweredSearchText) > -1 || employeeRole.indexOf(loweredSearchText) > -1;
    });
    const sortedEmployees = _.sortBy(filteredEmployees, employee => {
      return (employee._deleted ? 'zzzzzzz' : '') + employee.firstName + employee.lastName;
    });

    return <ul>
      {_.map(sortedEmployees, this.renderPerson.bind(this))}
    </ul>
  }

  renderActions(){
    console.log('checking renderActions for user: ', this.props.user);

    if(!(currentUserIsAdmin() || currentUserRole() === 'salesleader')){
      return null;
    }

    return (
      <div className="page-actions">
        <button className="button primary button-sm" onClick={this.beginCreatingNewUser.bind(this)}>Add User</button>
        {currentUserIsSuperAdmin() &&
          <button className="button grey-button button-sm" onClick={this.beginImportingUser.bind(this)}>Import Public User</button>
        }
      </div>
    );
  }
  // renderPeople(){
  //
  //   const filteredUsers = _.filter(this.props.users, user => {
  //     const userName = user.FirstName + ' ' + user.LastName;
  //     return userName.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1;
  //   });
  //
  //   const sortedUsers = _.sortBy(filteredUsers, user => {
  //     return user.LastName + user.FirstName;
  //   });
  //
  //   return <ul>
  //     {_.map(sortedUsers, this.renderPerson)}
  //   </ul>
  // }

  componentDidMount(){

  }

  render(){

    const loading = !this.props.employees;

    return (
      <Page
        permissionRequired="view_people_page"
        pageClass="people"
        loading={loading}
        hideSidebar={true}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
      >
        <h1>People</h1>
        <input type="text" placeholder="Search..." className="people-search" value={this.state.searchText} onChange={(e) => { this.setState({ searchText: e.target.value }) }} />
        {this.renderEmployees()}
        {this.renderActions()}
        <UpdateUserModal />
        {this.state.importingUser && <ImportUserModal hide={() => { this.setState({ importingUser: false }); }} />}
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    employees: state.employees.data,
    teams: state.teams.data,
    integration: IntegrationSelector(state),
  }
}

export default connect(mapStateToProps, { beginEditingUser })(PeoplePage);



// WEBPACK FOOTER //
// ./src/components/people/index.js